import { useSettings } from '@wix/tpa-settings/react';
import type { FC } from 'react';
import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';

import settingsParams from '../../../../settingsParams';
import CameraSmall from './CameraSmall';
import DividerSmall from './DividerSmall';
import EmojiSmall from './EmojiSmall';
import { classes } from './EmptyEditor.st.css';
import GifSmall from './GifSmall';
import VideoSmall from './VideoSmall';

type EmptyEditorProps = {
  setEditMode?: (value: boolean) => void;
};

export const EmptyEditor: FC<EmptyEditorProps> = ({ setEditMode }) => {
  const settings = useSettings();

  return (
    <div
      /* remove rootOld when merging specs.membersAbout.accessibleRce */
      className={setEditMode ? classes.root : classes.rootOld}
      {...(setEditMode ? { onClick: () => setEditMode(true) } : {})}
    >
      <Text tagName="div" className={classes.placeholder}>
        {settings.get(settingsParams.aboutDescriptionPlaceholder)}
      </Text>
      <div className={classes.footer}>
        <CameraSmall className={classes.icon} />
        <DividerSmall className={classes.icon} />
        <VideoSmall className={classes.icon} />
        <GifSmall className={classes.icon} />
        <EmojiSmall className={classes.icon} />
      </div>
    </div>
  );
};
